import type { FC } from 'react'
import styled from '@emotion/styled'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CardBase, * as Card from '@segment/matcha/recipes/Card'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import LessonLabel from './../../../components/LessonCard/LessonLabel'
import type { FeaturedLesson } from './FeaturedLessons'

export interface LessonCardProps {
  lesson: FeaturedLesson
}

const LessonCard: FC<LessonCardProps> = ({ lesson }) => {
  const { courseIcon, courseTitle, courseNumber, lessonNumber, numberOfLessons, title, description, url } = lesson
  const pageConfig = usePageConfig()

  return (
    <CardBase data-testid="featured-lesson" href={getAbsoluteUrl(`/academy/${url}`, pageConfig)}>
      <Card.Body>
        <Card.Copy>
          <Card.Accessories>
            <Card.AccessoriesRow>
              <StyledCardAuthor alt={courseIcon.title} src={courseIcon.src} />
              <Card.Label variant="textBoldSmall">{courseTitle}</Card.Label>
            </Card.AccessoriesRow>
            <LessonLabel courseNumber={courseNumber} lessonNumber={lessonNumber} numberOfLessons={numberOfLessons} />
          </Card.Accessories>
          <Card.Headline tag="h3">{title}</Card.Headline>
          <Card.Description>{description}</Card.Description>
        </Card.Copy>
        <Card.Action alignment="right">
          <ChevronRightIcon />
        </Card.Action>
      </Card.Body>
    </CardBase>
  )
}

const StyledCardAuthor = styled(Card.Author)`
  border-radius: 0;
  width: 22px;
  height: 22px;
  margin: 0;
`

export default LessonCard
